import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialOrderFeedbackReplyAddressState } from './initialState'
import { ReplyMode } from './types'

const slice = createSlice({
  name: 'orderFeedbackReplyAddress',
  initialState: initialOrderFeedbackReplyAddressState,
  reducers: {
    setReplyMode: (state, action: PayloadAction<ReplyMode>) => {
      state.replyMode = action.payload
    },
    setReplyAddress: (state, action: PayloadAction<string>) => {
      state.replyAddress = action.payload
    },
    resetForm: (
      state,
      action: PayloadAction<{ replyMode: ReplyMode; replyAddress: string }>
    ) => {
      state.replyMode = action.payload.replyMode
      state.replyAddress = action.payload.replyAddress
      state.persistedReplyMode = action.payload.replyMode
      state.persistedReplyAddress = action.payload.replyAddress
    },
    // Marks the current edit as saved. Called after a successful PATCH, which
    // makes the pane clean again and disables Publish until the next change.
    markFormPersisted: state => {
      state.persistedReplyMode = state.replyMode
      state.persistedReplyAddress = state.replyAddress
    },
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const reducer = slice.reducer
export const {
  setReplyMode,
  setReplyAddress,
  resetForm,
  markFormPersisted,
  setFormSubmitting,
} = slice.actions
